/* ==========================================================================
   Atlas Tea Co. — Breadcrumb
   Reveals the floating "← Back to {collection}" box once the shopper scrolls
   past the inline breadcrumb.

   Two Minimog-specific robustness measures:
   1. The box is moved to <body>. Minimog animates/wraps sections with CSS
      transforms, and a transformed ancestor becomes the containing block for
      position:fixed — which traps the box inside the section and breaks the
      "follows you down the page" behaviour. Re-parenting to <body> fixes that.
   2. Visibility is driven by a rAF-throttled scroll check on the breadcrumb's
      real rendered position (getBoundingClientRect), which is more reliable
      than an IntersectionObserver inside those transformed contexts.

   Desktop-only visibility is enforced by CSS (@media max-width:767px); this
   script only toggles the .is-visible class.
   ========================================================================== */
(function () {
  'use strict';

  function headerOffset() {
    return parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    ) || 61;
  }

  function initSection(section) {
    if (!section || section.dataset.atlasBcInit === 'true') return;

    var sentinel = section.querySelector('.atlas-bc');
    var backBox = section.querySelector('[data-atlas-bc-back]');
    if (!sentinel || !backBox) return;

    section.dataset.atlasBcInit = 'true';

    var sid = section.dataset.sectionId || '';
    backBox.setAttribute('data-atlas-bc-for', sid);

    // Remove any stale box left over from a previous render of this section
    // (e.g. re-editing in the theme customiser), then re-parent to <body>.
    var stale = document.querySelectorAll(
      'body > .atlas-bc__back[data-atlas-bc-for="' + sid + '"]'
    );
    for (var s = 0; s < stale.length; s++) {
      if (stale[s] !== backBox) stale[s].parentNode.removeChild(stale[s]);
    }
    if (backBox.parentElement !== document.body) {
      document.body.appendChild(backBox);
    }

    var ticking = false;
    function update() {
      ticking = false;
      var rect = sentinel.getBoundingClientRect();
      // Reveal once the breadcrumb has scrolled up under the sticky header.
      var scrolledPast = rect.bottom <= headerOffset();
      backBox.classList.toggle('is-visible', scrolledPast);
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function initAll() {
    var sections = document.querySelectorAll('.atlas-bc-section');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialise when the section is (re)loaded in the Shopify theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    var section = target && target.querySelector ? target.querySelector('.atlas-bc-section') : null;
    if (section) {
      initSection(section);
    } else {
      initAll();
    }
  });
})();
